// extracted by mini-css-extract-plugin
module.exports = {"root":"SubFooter_root__g8iI_","selectors":"SubFooter_selectors__lXYm8"};